import {
    Box,
    Button,
    CircularProgress,
    Paper
} from "@mui/material";

import TableContainer from "@mui/material/TableContainer";

import { useContext, useEffect, useState } from "react";
import { API_URL } from "../../utils/config";
import { v4 as uuidv4 } from "uuid";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import DataTable from "../../pages/Dashboard/DataTable";
import { TableContext } from "../../pages/Dashboard";
import SendPTCReport from "../SendPTCReport";
import SendMonthlySnapshotReport from "../SendMonthlySnapshotReport";
const DashBoardTable = () => {
    const { filters, loading, filterLoading, handleChangeData, handleChangeLoading } = useContext(TableContext);

    const headCells = [
        "utility_code",
        "utility_name",
        "alias",
        "state_id",
        "commodity",
        "class",
        "last_ptc_updated",
        "has_start_date",
        "has_end_date",
        "original_price",
        "graduated_standard_rate",
        "ptc_rate",
        "uom",
        "last_updated",
        "source",
    ];

    const [intialRows, setIntialRows] = useState([]);
    const [rows, setRows] = useState(intialRows);
    const [selected, setSelected] = useState([]);
    
    const handleSearch = (filters) => {
        const filteredData = intialRows.filter((item) =>
            filters.every((filter) => {
                if (filter.name === "date") return true;
                return filter.value !== "" ? item[filter.name] === filter.value : true;
            })
        );
        setRows([...filteredData]);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                handleChangeLoading(true);
                await getCurrentUser();
                const session = await fetchAuthSession();
                if (!session.tokens?.accessToken) {
                    throw new Error("No access token available");
                }
                const token = session.tokens.accessToken.toString();
                const res = await fetch(`${API_URL}/ptc/current`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                const data = await res.json();
                // const res1 = await fetch(`${API_URL}/utility/list`, {
                //     method: "POST",
                //     headers: {
                //         "Content-Type": "application/json",
                //         Authorization: `Bearer ${token}`,
                //     },
                // });
                // const data1 = await res1.json();
                const _rows = data.response.map((row) => ({ id: uuidv4(), ...row }));
                // setUtilities(data1.response);
                setIntialRows(_rows);
                setRows(_rows);
                handleChangeData(_rows)
                handleChangeLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                handleChangeLoading(false);
            }
        };
        getData();
    }, []);

    useEffect(() => {
        handleSearch(filters);
    }, [filters])

    const convertToCSV = (data) => {
        const csvRows = [];
        const headerCellNames = [
            "Utility Code",
            "Utility Name",
            "Alias",
            "State",
            "Commodity",
            "Class",
            "Last PTC Update",
            "Has Start Date",
            "Has End Date",
            "Exact Website Value",
            "Graduated Standard Rate",
            "PTC Rate",
            "UOM",
            "Last Scanned Date",
            "Source URL",
        ];
        csvRows.push(headerCellNames.join(","));

        // Add data rows
        data.forEach((row) => {
            const values = headCells.map((header) => JSON.stringify(row[header]));
            csvRows.push(values.join(","));
        });
        return csvRows.join("\n");
    };

    const downloadCSV = (data, filename = "table_data.csv") => {
        let _data = data;
        if (selected.length > 0) {
            _data = rows
                .map((row) => {
                    const i = selected.find((select) => select === row.id);
                    if (i) {
                        return row;
                    }
                    return null;
                })
                .filter((row) => row !== null);
        }

        const csvData = convertToCSV(_data);
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", filename);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div className="w-full pt-10 flex justify-center">
            <div className="w-[92%]  bg-white">
                <div className=" mt-10 mr-10 flex justify-end gap-4">
                    <SendPTCReport />
                    <SendMonthlySnapshotReport />
                    <Button variant="contained" onClick={() => downloadCSV(rows)}>
                        Download List
                    </Button>
                </div>
                <Box className="mt-10">
                    <Paper>
                        {
                            loading || filterLoading ?
                                <div style={{textAlign:"center"}}>
                                    <CircularProgress color="inherit" style={{ margin:"80px 0"}} />
                                </div>
                                :
                                <TableContainer>
                                    <DataTable
                                        rows={rows}
                                        selected={selected}
                                        setSelected={setSelected}
                                    />
                                </TableContainer>
                        }
                    </Paper>
                </Box>
            </div>
        </div>
    );
};
export default DashBoardTable;
